import React, { Component } from "react";
import Select from "react-select";
import * as tabConst from "../../../utils/TableConstanten";
import logger from "../../../logging/logger";
import { getInitialFirmenId } from "../../../utils/FormHelper";

class BenutzerForm extends Component {
  constructor(props) {
    super(props);
    this.default = {
      editForm: false,
      resourceId: null,
      firmenSelectOptions: [{ value: "ID", label: "Name" }],
      rolleSelectOptions: [{ value: "rolle", label: "Rolle wählen" }],
      mitarbeiterSelectOptions: [{ value: "ID", label: "Bereich wählen" }],
      bereichSelectOptions: [{ value: "ID", label: "Bereich wählen" }],
      selectedFirmenOption: [],
      selectedRolleOption: [],
      selectedMitarbeiterOption: [],
      selectedBereichOption: [],
      data: {
        username: "",
        email: "",
        pwd: "",
        rolle: "",
        firmenId: getInitialFirmenId(),
        bereiche: [],
        mitarbeiterId: null,
      },
    };
    this.functions = props.functions;

    this.onInputchange = this.onInputchange.bind(this);
    this.handleFirmenSelectChange = this.handleFirmenSelectChange.bind(this);
    this.handleRolleSelectChange = this.handleRolleSelectChange.bind(this);
    this.handleMitarbeiterSelectChange =
      this.handleMitarbeiterSelectChange.bind(this);
    this.handleBereichSelectChange = this.handleBereichSelectChange.bind(this);
    this.state = { ...this.default };
  }

  async validate(props) {
    const isEdit = !!props.resourceId;
    let data = { ...this.default.data };

    if (isEdit) {
      this.setState({ editForm: true, resourceId: props.resourceId });
      const user = await this.functions.fetchData(`${props.resourceName}/${props.resourceId}`);
      data = {
        ...data,
        username: user.username || "",
        email: user.email || "",
        rolle: user.rolle || "",
        pwd: user.pwd || "",
        firmenId: user.firmenId || null,
        bereiche: Array.isArray(user.bereiche) ? user.bereiche.map((b) => b.id) : [],
        mitarbeiterId: user.mitarbeiterId || null,
      };
    }

    if (global.auth.user.rolle !== "superadmin") {
      data.firmenId = global.auth.user.firmenId;
    }

    this.loadDependentData(props, data);
  }

  async loadDependentData(props, data) {
    const firmenId = data.firmenId;

    // Firmen-Auswahl
    const firmenSelectOptions = await this.functions.setFirmenSelectOptions(global.auth.user?.rolle === "superadmin");
    const selectedFirmenOption = firmenSelectOptions.find((opt) => opt.value === firmenId) || null;

    // Rollen-Auswahl
    let allowedRoles = props.schema.properties.rolle.enum;
    if (global.auth.user.rolle !== "superadmin") {
        const roleHierarchy = ['superadmin', 'admin', 'bearbeiter', 'bereichsleiter', 'bereichsleiter-betrachter', 'betrachter', 'mitarbeiter'];
        const userRoleIndex = roleHierarchy.indexOf(global.auth.user.rolle);
        if (userRoleIndex !== -1) {
            allowedRoles = roleHierarchy.slice(userRoleIndex);
        } else {
            allowedRoles = allowedRoles.filter(role => role !== 'superadmin');
        }
    }
    const rolleSelectOptions = allowedRoles.map(r => ({ value: r, label: r.charAt(0).toUpperCase() + r.slice(1) }));
    const selectedRolleOption = rolleSelectOptions.find((opt) => opt.value === data.rolle) || rolleSelectOptions[0];
    if (!data.rolle && selectedRolleOption) {
      data.rolle = selectedRolleOption.value;
    }

    // Bereichs-Auswahl
    const bereichSelectOptions = await this.setBereichSelectOptions(data.firmenId);
    const selectedBereichOption = Array.isArray(data.bereiche)
      ? bereichSelectOptions.filter((opt) => data.bereiche.includes(opt.value))
      : [];

    // Mitarbeiter-Auswahl
    const mitarbeiterSelectOptions = await this.setMitarbeiterSelectOptions(data.firmenId);
    const selectedMitarbeiterOption = mitarbeiterSelectOptions.find((m) => m.value === data.mitarbeiterId) || null;

    this.setState({
      data,
      firmenSelectOptions,
      selectedFirmenOption,
      rolleSelectOptions,
      selectedRolleOption,
      bereichSelectOptions,
      selectedBereichOption,
      mitarbeiterSelectOptions,
      selectedMitarbeiterOption,
    });
  }

  componentDidMount() {
    this.validate(this.props);
  }
  componentDidUpdate(newProps) {
    if (newProps !== this.props) {
      this.validate(newProps);
    }
  }

  /**
   * wir holen die Bereiche die Selektiert werdne können.
   * @returns Array mit Bereich IDs
   */
  async setMitarbeiterSelectOptions(firmenId) {
    let mitarbeiter = await this.functions.fetchData(
      tabConst.MITARBEITER,
      "?firmenId=" + firmenId + "&limit=ALL"
    );
    logger.log("mitarbeiter fetch ", mitarbeiter);
    let options = await Promise.all(
      mitarbeiter.data.map((m) => {
        let label = m.nachname + ", " + m.vorname + " (" + m.geburtstag + ")";
        return { value: m.id, label: label };
      })
    );
    return options;
  }

  /**
   * wir holen die Bereiche die Selektiert werdne können.
   * @returns Array mit Bereich IDs
   */
  async setBereichSelectOptions(firmenId) {
    let zuordnungen = await this.functions.fetchData(
      tabConst.ZUORDNUNG,
      "?firmenId=" + firmenId
    );
    logger.log("ke bereich fetch ", typeof zuordnungen, zuordnungen);
    let options = await Promise.all(
      zuordnungen.data.map((zuordnung) => {
        let label =
          "Bezeichnung: " + zuordnung.bezeichnung + " Typ: " + zuordnung.typ;
        return { value: zuordnung.id, label: label };
      })
    );
    return options;
  }

  /**
   * wenn Firma geändert wird, muss der select der Vorsorgen und MItarbeiter aktualisiert werden.
   * @param {*} e
   */
  async handleFirmenSelectChange(e) {
    // logger.log('test', e)
    // logger.log('inpChan', 'firmenId', e.value )
    
     const neueFirmenId = e.value;

    // Lade abhängige Daten separat
    const bereichSelectOptions = await this.setBereichSelectOptions(neueFirmenId);
    const mitarbeiterSelectOptions = await this.setMitarbeiterSelectOptions(neueFirmenId);

    this.setState(prev => ({
        selectedFirmenOption: e,
        data: {
            ...prev.data,
            firmenId: neueFirmenId,
            bereiche: [],           // Optional: Bereichsauswahl zurücksetzen
            mitarbeiterId: null     // Optional: Mitarbeiter zurücksetzen
        },
        bereichSelectOptions,
        mitarbeiterSelectOptions,
        selectedBereichOption: [], // reset bei Mehrfachauswahl
        selectedMitarbeiterOption: null
    }));
  }

  async handleRolleSelectChange(e) {
    // logger.log(e.target)
    this.setState({ selectedRolleOption: e }, () =>
      this.setState({ data: { ...this.state.data, rolle: e.value } })
    );
  }

  async handleMitarbeiterSelectChange(e) {
    // logger.log('test', e)
    logger.log("inpChan", "mitarbeiter", e);
    this.setState({ selectedMitarbeiterOption: e });
    this.setState({ data: { ...this.state.data, mitarbeiterId: e.value } });
  }

  async handleBereichSelectChange(e) {
    // logger.log('test', e)
    logger.log("inpChan", "bereich", e);
    this.setState({ selectedBereichOption: e });
    if (Array.isArray(e)) {
      //wenn array dann selectBox Zuordnungen
      let zuordnungId = Array.from(e, (option) => option.value);
      logger.log("inpChan", "firmenkarteiIds", zuordnungId);
      this.setState({ data: { ...this.state.data, bereiche: zuordnungId } });
    }
  }

  onInputchange(event) {
    this.setState({
      data: { ...this.state.data, [event.target.name]: event.target.value },
    });
    // logger.log('inpChan', event.target.name, event.target.value )
  }

  async put_post_fetch(method, url) {
    logger.log("save this:", this.state.data);
    let req = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: global.auth.authToken.token,
      },
      body: JSON.stringify(this.state.data),
    };
    const response = await fetch(url, req);
    const data = await response.json(); // Versucht, den Body als JSON zu parsen
    if (!response.ok) {
      // Wenn die Antwort nicht erfolgreich war (z.B. Status 400),
      // wird hier ein Fehler geworfen. `data` enthält oft die Fehlermeldung vom Server.
      logger.error("Fehler vom Server:", data);
      return data;
    }
    logger.log("User " + data.id + " - " + data.email + " angelegt");
    return data; // Gibt die erfolgreichen Daten zurück
  }

  saveOrUpdate() {
    //Update oder Save?
    if (this.state.editForm) {
      //wird wurden als Edit aufgerufen
      return this.put_post_fetch(
        "PUT",
        global.api_url + tabConst.BENUTZER + "/" + this.state.resourceId
      );
    } else {
      return this.put_post_fetch("POST", global.api_url + tabConst.BENUTZER);
    }
  }

  render() {
    return (
      <form>
        {/* Firma */}
        <div className="form-group">
          <label htmlFor="firmen" className="control-label">
            Firma
          </label>
          <Select
            placeholder="Auswählen"
            options={this.state.firmenSelectOptions}
            value={this.state.selectedFirmenOption}
            name="firmenId"
            className="basic-multi-select"
            isDisabled={this.props.viewOnly}
            onChange={this.handleFirmenSelectChange}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#ffeebe",
                primary: "#ffd370",
              },
            })}
          />
        </div>
        {/* Rolle */}
        <div className="form-group">
          <label htmlFor="rolle" className="control-label">
            Rolle
          </label>
          <Select
            placeholder="Auswählen"
            options={this.state.rolleSelectOptions}
            value={this.state.selectedRolleOption}
            name="rolle"
            className="basic-multi-select"
            isDisabled={this.props.viewOnly}
            onChange={this.handleRolleSelectChange}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#ffeebe",
                primary: "#ffd370",
              },
            })}
          />
        </div>
        {/* Bereich wenn rolle === Bereichsleiter */}
        {(this.state.data.rolle === "bereichsleiter" || this.state.data.rolle === "bereichsleiter-betrachter") && (
          <div className="form-group">
            <label htmlFor="bereich" className="control-label">
              Bereich <em>nur bei Bereichsleitern füllen</em>
            </label>
            <Select
              placeholder="Auswählen"
              options={this.state.bereichSelectOptions || []}
              value={this.state.selectedBereichOption}
              isMulti
              name="bereich"
              className="basic-multi-select"
              isDisabled={this.props.viewOnly}
              onChange={this.handleBereichSelectChange}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "#ffeebe",
                  primary: "#ffd370",
                },
              })}
            />
          </div>
        )}
        {/* Mitarbieter zuordnung wenn Rolle === mitarbieter */}
        {this.state.data.rolle === "mitarbeiter" && (
          <div className="form-group">
            <label htmlFor="bereich" className="control-label">
              Zugeordneter Mitarbeiter
            </label>
            <Select
              placeholder="Auswählen"
              options={this.state.mitarbeiterSelectOptions || []}
              value={this.state.selectedMitarbeiterOption}
              name="mitarbeiter"
              className="basic-multi-select"
              isDisabled={this.props.viewOnly}
              onChange={this.handleMitarbeiterSelectChange}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "#ffeebe",
                  primary: "#ffd370",
                },
              })}
            />
          </div>
        )}
        {/* Username */}
        <div className="form-group">
          <label htmlFor="username" className="control-label">
            Benutzername
          </label>
          <input
            type="text"
            id="username"
            name="username"
            className="form-control"
            value={this.state.data.username}
            onChange={this.onInputchange}
            disabled={this.props.viewOnly}
          />
        </div>
        {/* Email */}
        <div className="form-group">
          <label htmlFor="email" className="control-label">
            Email
          </label>
          <input
            type="text"
            id="email"
            name="email"
            className="form-control"
            value={this.state.data.email}
            onChange={this.onInputchange}
            disabled={this.props.viewOnly}
          />
        </div>
        {/* neues Pwd */}
        <div className="form-group">
          <label htmlFor="pwd" className="control-label">
            Passwort
          </label>
          <input
            type="text"
            id="pws"
            name="pwd"
            className="form-control"
            value={this.state.data.pwd}
            onChange={this.onInputchange}
            disabled={this.props.viewOnly}
          />
        </div>
      </form>
    );
  }
}
export default BenutzerForm;
